export const interviewConductStatus = {
  STARTING_INTERVIEW: "Starting Interview...",
  BOT_SPEAKING: "Bot speaking...",
  BOT_LISTENING: "Bot listening...",
  INTERVIEWEE_SPEAKING: "Candidate speaking...",
  WAITING_FOR_INTERVIEWEE_RESPONSE: "Waiting for candidate's response",
  WAITING_FOR_INTERVIEWER_RESPONSE: "Waiting for interviewer's response...",
  RECORDING_INTERVIEWEE_RESPONSE: "Recording interviewee's response...Please speak now",
};
